/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sage_Tame_Heron_PaceInputs */

const en_sage_tame_heron_pace = /** @type {(inputs: Sage_Tame_Heron_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments match your filters`)
};

const de_sage_tame_heron_pace = /** @type {(inputs: Sage_Tame_Heron_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Segmente passen zu Ihren Filtern`)
};

/**
* | output |
* | --- |
* | "No segments match your filters" |
*
* @param {Sage_Tame_Heron_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sage_tame_heron_pace = /** @type {((inputs?: Sage_Tame_Heron_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sage_Tame_Heron_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sage_tame_heron_pace(inputs)
	return de_sage_tame_heron_pace(inputs)
});